import { stringify } from 'query-string';

interface IGetCustomListsByIdURL {
  expand?: 'none' | 'permissions' | 'entities' | 'all';
}

const getCustomListsByIdURL = (args: IGetCustomListsByIdURL = {}): string => {
  const { expand } = args;

  const params = stringify({
    expand,
  });

  return `/api/customEntityLists/byIds?${params}`;
};

export default getCustomListsByIdURL;
